/* TR1 Birthday LP v3 — tiers, one-time link, accordions. Vanilla, no deps. */
(function(){
  function initBuy(root){
    var form = root.querySelector('form[data-tr1-buy]'); if(!form) return;
    var idIn = form.querySelector('input[name="id"]');
    var spIn = form.querySelector('input[name="selling_plan"]');
    var ctaP = form.querySelector('[data-cta-price]');
    var ren = root.querySelector('[data-renew]');
    function apply(r){
      idIn.value = r.dataset.variant || idIn.value;
      if (r.dataset.plan) { spIn.value = r.dataset.plan; spIn.disabled = false; } else { spIn.value = ''; spIn.disabled = true; }
      if (ctaP) ctaP.textContent = r.dataset.price || '';
      if (ren) ren.innerHTML = r.dataset.renew || '';
    }
    root.querySelectorAll('input[name="tr1-tier"]').forEach(function(r){
      r.addEventListener('change', function(){ apply(r); });
      if (r.checked) apply(r);
    });
    var once = root.querySelector('[data-one-time]');
    if (once) once.addEventListener('click', function(e){
      e.preventDefault();
      if (!once.dataset.variant) { alert('Set the one-time variant id in the theme editor.'); return; }
      idIn.value = once.dataset.variant; spIn.value=''; spIn.disabled = true; form.submit();
    });
  }
  function initAcc(root){
    root.querySelectorAll('details.tr1-acc').forEach(function(d){
      d.addEventListener('toggle', function(){ var s=d.querySelector('summary span:last-child'); if(s) s.textContent = d.open ? '–' : '+'; });
    });
  }
  function init(){ document.querySelectorAll('.tr1-bday').forEach(function(r){ initBuy(r); initAcc(r); }); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
